import Vue from 'vue'
import Router from 'vue-router'
import StandaloneLayout from '@/layout/StandaloneLayout.vue'
import InTransit from '@/views/in-transit/InTransit.vue'
import FullMap from '@/views/in-transit/FullMap.vue'
import AlarmManage from '@/views/in-transit/AlarmManage.vue'
import FenceManage from '@/views/in-transit/FenceManage.vue'
import DriverManage from '@/views/in-transit/DriverManage.vue'
import VehicleManage from '@/views/in-transit/VehicleManage.vue'
import AddressBookManage from '@/views/in-transit/AddressBookManage.vue'
import RouteManage from '@/views/in-transit/RouteManage.vue'
import WaybillForm from '@/views/in-transit/WaybillForm.vue'
import WaybillMapPage from '@/views/in-transit/WaybillMapPage.vue'
import RouteConfigForm from '@/views/in-transit/RouteConfigForm.vue'
import RouteForm from '@/views/in-transit/RouteForm.vue'
import Login from '@/views/auth/Login.vue'
import UserManage from '@/views/auth/UserManage.vue'
import { getCurrentUser, hasPermission } from '@/utils/auth'
import { firstAuthorizedPath } from '@/utils/permissionNavigation'
import RoleManage from '@/views/auth/RoleManage.vue'
import MenuManage from '@/views/auth/MenuManage.vue'
import DictionaryManage from '@/views/auth/DictionaryManage.vue'
import SystemSettings from '@/views/auth/SystemSettings.vue'
import ApiAuditManage from '@/views/auth/ApiAuditManage.vue'
import ApiDocs from '@/views/auth/ApiDocs.vue'
import CallbackSettings from '@/views/auth/CallbackSettings.vue'
import TruckPosition from '@/views/business/position.vue'
import TruckHistory from '@/views/business/history.vue'
import TruckNetworkAccess from '@/views/functions/networkAccess.vue'
import ForbiddenPage from '@/views/auth/ForbiddenPage.vue'
import embedRoutes from '@/embed/embedRoutes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...embedRoutes,
    {
      path: '/login',
      name: 'InTransitLogin',
      component: Login,
      meta: { title: '登录', public: true }
    },
    {
      path: '/waybills/share/:shareId',
      name: 'LingDongWaybillShareMapName',
      component: WaybillMapPage,
      meta: { title: '运单地图分享', public: true }
    },
    {
      path: '/',
      component: StandaloneLayout,
      children: [
        { path: '', redirect: '/waybills' },
        { path: '/waybills', name: 'LingDongInTransitName', component: InTransit, meta: { title: '运单管理', permission: 'waybill:list' } },
        { path: '/full-map', name: 'LingDongFullMapName', component: FullMap, meta: { title: '全图可视', permission: 'fullmap:view' } },
        { path: '/alarms', name: 'LingDongAlarmName', component: AlarmManage, meta: { title: '告警管理', permission: 'alarm:list' } },
        { path: '/fences', name: 'LingDongFenceName', component: FenceManage, meta: { title: '运单围栏', permission: 'fence:list' } },
        { path: '/drivers', name: 'LingDongDriverName', component: DriverManage, meta: { title: '司机管理', permission: 'driver:list' } },
        { path: '/vehicles', name: 'LingDongVehicleName', component: VehicleManage, meta: { title: '车辆管理', permission: 'vehicle:list' } },
        { path: '/vehicle-monitor/positions', name: 'VehicleMonitoringPositions', component: TruckPosition, meta: { title: '货车位置查询', permission: 'truck:position' } },
        { path: '/vehicle-monitor/tracks', name: 'VehicleMonitoringTracks', component: TruckHistory, meta: { title: '货车历史轨迹', permission: 'truck:track' } },
        { path: '/vehicle-monitor/network', name: 'VehicleMonitoringNetwork', component: TruckNetworkAccess, meta: { title: '货车入网校验', permission: 'truck:network' } },
        { path: '/addresses', name: 'LingDongAddressBookName', component: AddressBookManage, meta: { title: '地址簿', permission: 'address:list' } },
        { path: '/routes', name: 'LingDongRouteManageName', component: RouteManage, meta: { title: '路线管理', permission: 'route:list' } },
        { path: '/roles', name: 'SystemRoleManage', component: RoleManage, meta: { title: '角色管理', permission: 'system:role:list' } },
        { path: '/menus', name: 'SystemMenuManage', component: MenuManage, meta: { title: '菜单管理', permission: 'system:menu:list' } },
        { path: '/dictionaries', name: 'SystemDictionaryManage', component: DictionaryManage, meta: { title: '数据字典', permission: 'system:dict:list' } },
        { path: '/settings', name: 'SystemSettings', component: SystemSettings, meta: { title: '系统配置', permission: 'system:config:list' } },
        { path: '/api-audits', name: 'ApiAuditManage', component: ApiAuditManage, meta: { title: '接口调用记录', permission: 'system:api-audit:list' } },
        { path: '/api-docs', name: 'SystemApiDocs', component: ApiDocs, meta: { title: '接口文档', permission: 'system:api-doc:list' } },
        { path: '/callback-settings', name: 'SystemCallbackSettings', component: CallbackSettings, meta: { title: '回调配置', permission: 'system:callback:list' } },
        { path: '/forbidden', name: 'PermissionForbidden', component: ForbiddenPage, meta: { title: '暂无权限' } },
        { path: '/users', name: 'InTransitUserManage', component: UserManage, meta: { title: '用户管理', permission: 'system:user:list' } },
        { path: '/waybills/create', name: 'LingDongWaybillCreateName', component: WaybillForm, meta: { title: '新增运单', permission: 'waybill:add' } },
        { path: '/waybills/edit/:transportNo', name: 'LingDongWaybillEditName', component: WaybillForm, meta: { title: '编辑运单', permission: 'waybill:edit' } },
        { path: '/waybills/map/:transportNo', name: 'LingDongWaybillMapName', component: WaybillMapPage, meta: { title: '运单地图', permission: ['waybill:monitor', 'fullmap:view'] } },
        { path: '/routes/create', name: 'LingDongRouteCreateName', component: RouteConfigForm, meta: { title: '新增路线', permission: 'route:add' } },
        { path: '/routes/edit/:id', name: 'LingDongRouteEditName', component: RouteConfigForm, meta: { title: '编辑路线', permission: 'route:edit' } },
        { path: '/routes/planner', name: 'LingDongRoutePlannerName', component: RouteForm, meta: { title: '路线规划', permission: 'route:add' } },
        { path: '/routes/view/:id', name: 'LingDongRouteViewName', component: RouteForm, meta: { title: '查看路线', permission: 'route:list' } }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta && to.meta.title ? `${to.meta.title} - 在途智运` : '在途智运'
  if (to.matched.some(record => record.meta && record.meta.public)) {
    next()
    return
  }
  try {
    const user = await getCurrentUser(true)
    const permission = to.name === 'LingDongRoutePlannerName'
      ? (to.query.routeId ? 'route:edit' : 'route:add')
      : to.meta && to.meta.permission
    if (permission && !hasPermission(permission, user)) {
      const target = to.path === '/waybills' ? firstAuthorizedPath(user) : '/forbidden'
      next({ path: target, replace: true })
      return
    }
    next()
  } catch (error) {
    next({ path: '/login', query: { redirect: to.fullPath }, replace: true })
  }
})

export default router
